import React from 'react';
import './Banner.css'
import highlight from '../../Images/Highlight.svg'
import arrow from '../../Images/Arrow.svg'
import { Link } from 'react-router-dom';

const Banner = () => {
    return (
        <div className='banner-main py-5'>
            <div className="container">
                <div className="row">
                    <div className="col-md-9">
                        <img src={highlight} alt="" />
                        <h1 className='py-5'>FIND THE BEST USED CAR FOR YOUR BUDGET
                        </h1>
                        <img src={arrow} alt="" />
                        <div className='py-5'>
                            <Link className='banner-button' to="about-us">Get a quote</Link>
                        </div>

                        <div>
                            <p className='text-white'>
                                Say hello to confidence. Find out if you’ll be approved for finance with Oodle in just a few minutes, without affecting your credit score. 15% APR Representative.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Banner;